"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ContractTable = void 0;
const mithril_1 = __importDefault(require("mithril"));
const app_1 = require("../../../app");
const contract_1 = require("../../../model/contract");
const helpers_1 = require("../../../utils/helpers");
const table_renderers_1 = require("../../../utils/table_renderers");
const right_panel_1 = require("../../../widgets/right_panel");
const table_1 = require("../../../widgets/table");
const contract_export_window_1 = require("./contract_export_window");
const new_contract_form_1 = require("./new_contract_form");
exports.ContractTable = (0, table_1.createTable)({
    id: "contractTable",
    provider: contract_1.ContractProvider,
    title: "Forfaits",
    topMenuRight: () => {
        return [
            (0, mithril_1.default)("a", { class: "button is-success with-margin", onclick: () => {
                    new_contract_form_1.NewContractForm.show({});
                } }, (0, mithril_1.default)("span", { class: "icon is-small" }, (0, mithril_1.default)("i", { class: "fas fa-plus" })), (0, mithril_1.default)("span", "Nouveau forfait")),
            (0, mithril_1.default)("a", { class: "button is-primary", onclick: () => { contract_export_window_1.ContractExportWindow.show(); } }, (0, helpers_1.iconSpan)("fa-download", "is-small"), (0, mithril_1.default)("span", "Exporter"))
        ];
    },
    filters: {
        "without_payment_received": "Moyen de paiement non reçu",
        "enabled": "Activé uniquement",
        "disabled": "Désactivé uniquement"
    },
    fields: [
        {
            name: "contracts.id",
            sortable: true,
            label: "#",
            renderer: (x) => x.id
        },
        {
            name: "reference",
            sortable: true,
            label: "# de facture",
            renderer: (x) => {
                var _a;
                if (x.invoice) {
                    return (0, helpers_1.tag)((_a = x.invoice) === null || _a === void 0 ? void 0 : _a.reference);
                }
                else {
                    return (0, helpers_1.empty)();
                }
            }
        },
        {
            name: "users.first_name,users.last_name",
            sortable: true,
            label: "Client",
            renderer: table_renderers_1.TableRenderers.resourceLink("clients", "show", (mdl) => mdl.client.id, (mdl) => mdl.client.name)
        },
        {
            name: "commercial_offers.name",
            sortable: true,
            label: "Template d'offre",
            renderer: table_renderers_1.TableRenderers.resourceLink("offers", "show", (mdl) => mdl.offer.id, (mdl) => mdl.offer.name)
        },
        {
            name: "remaining_minutes",
            sortable: true,
            label: "Temps restant",
            renderer: (x, attr) => {
                if (x.active) {
                    return (0, mithril_1.default)("span", table_renderers_1.TableRenderers.time(x, attr));
                }
                else {
                    return [(0, mithril_1.default)("span", table_renderers_1.TableRenderers.time(x, attr)), (0, helpers_1.iconSpan)("fa-ban")];
                }
            }
        },
        {
            name: "payment_received",
            sortable: false,
            label: "Paiement Reçu",
            renderer: (model, _value) => {
                return (0, mithril_1.default)("span", {
                    style: "cursor: pointer",
                    onclick: () => {
                        app_1.App.get(`/contracts/${model.id}/toggle_payment_received`).then((_data) => {
                            model.payment_received = !!model.payment_received;
                            exports.ContractTable.fetch();
                        });
                    }
                }, model.payment_received ? (0, helpers_1.tag)("Oui", "success") : (0, helpers_1.tag)("Non", "danger"));
            }
        },
        {
            name: "active",
            sortable: false,
            label: "Actif",
            renderer: table_renderers_1.TableRenderers.bool
        },
        {
            name: "expires_at",
            sortable: true,
            label: "Date d'expiration",
            renderer: table_renderers_1.TableRenderers.date
        },
    ],
    actions: (obj) => {
        return (0, mithril_1.default)("div", { class: "" }, (0, mithril_1.default)("a", { class: "button is-primary with-margin", onclick: () => { right_panel_1.RightPanel.open("contracts", obj.id, "show"); } }, "Afficher"));
    }
});
